import React from 'react';
import Main from './frames/Main';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import './App.css';

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/slides/:projID/:moduleID/:slideID" element={<div className="App"><Main /></div>} />
                <Route path="/*" element={<div className="App"><Main /></div>} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
